export { SelectCustomerAddress } from './src/select-customer-address';
export type { SoldToAddressesType } from './src/select-customer-address';
